import { render, staticRenderFns } from "./LocalizationSwitcher.vue?vue&type=template&id=08011136&scoped=true"
import script from "./LocalizationSwitcher.vue?vue&type=script&lang=js"
export * from "./LocalizationSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LocalizationSwitcher.vue?vue&type=style&index=0&id=08011136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08011136",
  null
  
)

export default component.exports